import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import rightArrow from '../../images/arrow-right-blue-textlink.svg';
import '../../sass/components/flexibleModules/_components.fullWidthMastheadWithGridComponent.scss';

const FullWidthMastheadWithGridComponent = ({ data }) => {
    return (
        <div className="cp-fullWidthMastheadWithGrid" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-cp-fullWidthMastheadWithGrid__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth/16+"rem") : ""}`, margin: "0 auto" }}>
                <div className="cp-fullWidthMastheadWithGrid__header l--flex">
                    {data.fullWidthMastheadSectionWithGridTextHeader &&
                        <h2>{data.fullWidthMastheadSectionWithGridTextHeader}</h2>
                    }
                    <div className="cp-fullWidthMastheadWithGrid__header-right">
                        {data.fullWidthMastheadSectionWithGridTextTeaser &&
                            <div dangerouslySetInnerHTML={{ __html: data.fullWidthMastheadSectionWithGridTextTeaser }} />
                        }
                        {data.fullWidthMastheadSectionWithGridTextLink &&
                            <a href={data.fullWidthMastheadSectionWithGridTextLink.url} target={data.fullWidthMastheadSectionWithGridTextLink.target}>
                                <span>{data.fullWidthMastheadSectionWithGridTextLink.title}</span>
                                    <img src={rightArrow} alt="" />
                                </a>
                        }
                    </div>
                </div>
                <div className="cp-fullWidthMastheadWithGrid__image">
                    {data.fullWidthMastheadSectionWithGridTextImage &&
                        <GatsbyImage image={getImage(data.fullWidthMastheadSectionWithGridTextImage)} alt={data.fullWidthMastheadSectionWithGridTextImage.altText} />
                    }
                </div>
                {data.fullWidthMastheadSectionWithGridTextGrid &&
                    <div className="cp-fullWidthMastheadWithGrid__grid l--flex">
                        {data.fullWidthMastheadSectionWithGridTextGrid.map((gridItems, index) => (
                            <div className="l-section" key={index}>
                                {gridItems.header &&
                                    <h4>{gridItems.header}</h4>
                                }
                                {gridItems.teaser &&
                                    <p dangerouslySetInnerHTML={{ __html: gridItems.teaser }} />
                                }
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default FullWidthMastheadWithGridComponent;